import VueI18n from 'vue-i18n'
import DermisPlugin from '@aspectus/vue-dermis';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSlider from 'vue-slider-component'
import Tag from '@aspectus/vue-tag'
import VueGrid from '@aspectus/vue-grid'
import ResourceComponents from '@resource'
import VueBem from '@aspectus/vue-bem'
import VueSelectionController from '@aspectus/vue-selection-controller'
import VueMultiselect from 'vue-multiselect'
import VueAccordion from '@ztrehagem/vue-accordion'
import PortalVue from 'portal-vue'

export function install(Vue) {
  Vue.use(PortalVue)
  Vue.use(VueI18n)
  Vue.use(VueMultiselect)
  Vue.use(ResourceComponents)
  Vue.use(VueSelectionController)
  Vue.use(VueGrid)
  Vue.use(Tag)
  Vue.use(VueGoogleMaps, {
    load: {
      key: window.gmap,
      libraries: 'places',
    },
  })
  Vue.use(DermisPlugin, {
    prefix: 'ds-',
    prefixType: 't-',
    prefixUtils: 'u-',
  })
  Vue.use(VueBem, {
    blockNameKey: 'block',
  })
  Vue.component('vue-accordion', VueAccordion)
  Vue.component('range-slider', VueSlider)
}

export default { install }
